import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../hooks/useFetch";
import Swal from "sweetalert2";

// https://dev.to/bytebodger/constructors-in-functional-components-with-hooks-280m
// https://reactjs.org/docs/hooks-state.html
// https://beta.reactjs.org/reference/react/useRef
// https://ui.dev/react-router-pass-props-to-link

export default function Exemplo() {
    const { get, post, put } = useFetch();
    const defaultState = {
        acao: "Visualizar",
        exemplo: { id_exemplo: "", nome: "", descricao: "" }
    }

    /* objeto recebido do state={} do <Link> da página anterior
    ** https://v5.reactrouter.com/web/api/location  https://v5.reactrouter.com/web/api/Hooks/uselocation */
    let location = useLocation();
    let navigate = useNavigate();

    // https://v5.reactrouter.com/web/example/url-params
    let { id } = useParams();

    useEffect(() => {
        if (id === "criar")
            setState({ ...state, acao: "Criar" });
        else
            buscarExemplo(id).then(data => setState({ ...state, exemplo: data }))
    }, [id])


    /* https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    ** define o state inicial do componente, o useState retorna um array com 2 elementos, 
    ** objeto state e função setState pra atualizar o objeto state */
    const [state, setState] = useState(() => {
        // se a página anterior passou um state, retorna ele
        if (location.state) {
            if (location.state.acao) {
                defaultState.acao = location.state.acao;
            }
        }
        // senão, retorna um objeto vazio
        return defaultState;
    });

    /* https://reactjs.org/docs/hooks-reference.html#functional-updates
    ** handleChange: quando um campo do formulário é alterado, atualiza o objeto state */
    function changeExemplo(event) {
        let name = event.target.name; // name do campo que disparou o evento
        let value = event.target.value; // value do campo    

        // ex: se o campo com name Nome for alterado, atualiza o objeto state com o novo valor do campo Nome
        // { Nome: "novo valor do campo Nome" }
        setState(prevState => ({
            ...prevState,
            exemplo: {
                ...prevState.exemplo,
                [name]: value
            }
        }));
    }

    async function buscarExemplo(id) {
        try {
            let response = await get(`/exemplo/${id}`);
            console.log(response)
            if (response.ok) {
                let dados = await response.result;
                if (dados === null)
                    return defaultState.exemplo;
                return dados.data;
            } else {
                return defaultState.exemplo;
            }
        } catch (error) {
            console.error("Erro no buscarExemplo():", error);
        }
    }

    async function salvarExemplo() {
        let method = state.acao === "Criar" ? post : put;
        try {
            let response = await method(`/exemplo/${state.exemplo.id_exemplo}`, state.exemplo);
            if (response.ok) {
                navigate("/admin/exemplos");
            } else {
                Swal.fire({
                    title: "Não foi possível salvar o exemplo",
                    text: "Erro ao salvar exemplo",
                    icon: "error",
                })
            }
        } catch (error) {
            console.error("Erro no salvarExemplo():", error);
        }
    }

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/exemplos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Exemplos
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4">
                    <div className="section-title-modern mb-4">
                        <div className="title-accent"></div>
                        <h2 className="admin-title">{state.acao} Exemplo</h2>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Nome do Exemplo</Form.Label>
                                <Form.Control
                                    type="text"
                                    className="input-moderno"
                                    name="nome"
                                    placeholder="Digite o título do exemplo"
                                    value={state.exemplo.nome ?? ""}
                                    onChange={changeExemplo}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                            
                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Descrição</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    className="input-moderno"
                                    name="descricao"
                                    placeholder="Detalhes sobre este exemplo..."
                                    value={state.exemplo.descricao ?? ""}
                                    onChange={changeExemplo}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvarExemplo}>
                                    Salvar Alterações
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}